import { useRequestHomadataEvaluationMutation } from 'src/hooks/__generated__/queries';
import { Ad } from 'src/types/__generated__/graphql';

export const useRequestPropertyEstimation = () => {
    const [requestHomadataEvaluationMutation, { loading }] = useRequestHomadataEvaluationMutation();

    const requestPropertyEstimation = async (adId: string) => {
        const { data } = await requestHomadataEvaluationMutation({
            variables: {
                adId,
            },
            refetchQueries: [
                {
                    query: Ad,
                    variables: {
                        id: adId,
                    },
                },
            ],
            awaitRefetchQueries: true,
        });

        return data?.requestHomadataEvaluation;
    };

    return {
        requestPropertyEstimation,
        loading,
    };
};
